__turbopack_context__.v({
  "description": "_1-wb3G_description",
  "filters": "_1-wb3G_filters",
  "heading": "_1-wb3G_heading",
  "plenty-card": "_1-wb3G_plenty-card",
  "plenty-tag": "_1-wb3G_plenty-tag",
  "products": "_1-wb3G_products",
  "products-container": "_1-wb3G_products-container",
  "round-all": "_1-wb3G_round-all",
  "shape": "_1-wb3G_shape",
  "summary-and-filters": "_1-wb3G_summary-and-filters",
  "switch": "_1-wb3G_switch",
  "switch-slider": "_1-wb3G_switch-slider",
  "tab": "_1-wb3G_tab",
  "tab-card": "_1-wb3G_tab-card",
  "tab-description": "_1-wb3G_tab-description",
  "tab-list": "_1-wb3G_tab-list",
  "tabs": "_1-wb3G_tabs",
  "title": "_1-wb3G_title",
  "toggle": "_1-wb3G_toggle",
  "toggle-option": "_1-wb3G_toggle-option",
});
